import React from 'react';
import { IEnhancedDynamicDisplay } from '.';
import { IFormFieldInputBaseProps } from '@components/form-fields';
import EnhancedDisplayWrapper from './EnhancedDisplayWrapper';

export interface IDynamicDisplayFieldProps extends IFormFieldInputBaseProps {
  property: IEnhancedDynamicDisplay;
  value: any;
  error?: any;
  disabled?: boolean;
  material?: boolean;
  cdnUrl: string;
  astAccountName?: string;
  tooltip: boolean;
  currencySymbol?: string;
}

const DynamicDisplayField: React.FC<IDynamicDisplayFieldProps> = ({
  property,
  value,
  cdnUrl,
  astAccountName,
  tooltip,
  currencySymbol,
  ...props
}) => {
  function renderField() {
    const { title, ...restOfProperties } = property;
    // title = restOfProperties.required && !isEmpty(title) ? `${title}*` : title;

    return (
      <EnhancedDisplayWrapper
        currencySymbol={currencySymbol}
        phoneNumberPattern={''}
        {...props}
        title={title}
        {...restOfProperties}
        toolTip={tooltip}
      />
    );
  }

  return <>{renderField()}</>;
};

export default DynamicDisplayField;
